import { render, staticRenderFns } from "./DashboardIdentityVerification.vue?vue&type=template&id=cd445b42"
import script from "./DashboardIdentityVerification.vue?vue&type=script&lang=js"
export * from "./DashboardIdentityVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports